export function copyToClipboard(text:string) {
	let input = document.createElement("input");
	input.value = text;
	input.select();
	input.setSelectionRange(0, text.length);
	navigator.clipboard.writeText(input.value);
	input.remove();
}